const GET_ASSET_ITEM_STATUS_PURCHASE_DETAILS = 'GET_ASSET_ITEM_STATUS_PURCHASE_DETAILS'
const SET_ASSET_ITEM_STATUS_PURCHASE_DETAILS = 'SET_ASSET_ITEM_STATUS_PURCHASE_DETAILS'

 const SET_IS_ASSET_ITEM_STATUS_PURCHASE_DETAILS_CALLED = "SET_IS_ASSET_ITEM_STATUS_PURCHASE_DETAILS_CALLED"

export {
    GET_ASSET_ITEM_STATUS_PURCHASE_DETAILS,
    SET_ASSET_ITEM_STATUS_PURCHASE_DETAILS,
    SET_IS_ASSET_ITEM_STATUS_PURCHASE_DETAILS_CALLED
}
